import { ColorPageHeader } from '../generic/header/ColorPageHeader';
export const AboutUsHero = () => {
  return (
    <ColorPageHeader
      mainHeader='About company'
      secondaryHeader='Our company combines creativity and technology to develop innovative solutions that meet the modern needs of businesses'
    />
  );
};
